module.exports = __webpack_public_path__ + "img/eye.2630f12.svg";